<div class="min-h-screen">

  <!-- PAGE HEADER -->
  <div class="bg-white border border-slate-200 rounded-2xl px-6 py-5 mb-5 shadow-sm">

    <div class="flex items-center justify-between flex-wrap gap-4">

      <!-- LEFT -->
      <div>
        <h2 class="text-2xl font-bold text-slate-800">
          {{ 'SETUP.ROLES.TITLE' | translate }}
        </h2>

        <p class="text-sm text-slate-500 mt-1">
          {{ 'SETUP.ROLES.SUBTITLE' | translate }}
        </p>
      </div>

 

    </div>

  </div>

  <!-- MAIN GRID -->
  <div class="grid grid-cols-12 gap-5">

    <!-- LEFT PANEL -->
    <div class="col-span-12 xl:col-span-3">

      <div class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">

        <!-- TOP -->
        <div class="px-5 py-4 border-b border-slate-200">

          <div class="flex items-center justify-between">

            <div>
              <h3 class="text-lg font-semibold text-slate-800">
                {{ 'SETUP.ROLES.ROLES' | translate }}
              </h3>

              <p class="text-xs text-slate-500 mt-1">
                {{ 'SETUP.ROLES.SYSTEM_USER_ROLES' | translate }}
              </p>
            </div>

            <div
              class="w-9 h-9 rounded-xl bg-indigo-100 text-indigo-700 flex items-center justify-center"
            >
              <i class="pi pi-users text-sm"></i>
            </div>

          </div>

        </div>

        <!-- ROLE LIST -->
        <div class="p-3 space-y-3 max-h-[720px] overflow-auto">

          <div
            *ngFor="let role of roles"
            (click)="selectRole(role)"
            class="border rounded-xl p-4 cursor-pointer transition-all"
            [ngClass]="
              selectedRole?.id === role.id
                ? 'border-indigo-500 bg-indigo-50'
                : 'border-slate-200 bg-white hover:border-indigo-300'
            "
          >

            <div class="flex items-center justify-between">

              <div class="flex items-center gap-3">

                <!-- ICON -->
                <div
                  class="w-11 h-11 rounded-xl flex items-center justify-center font-bold text-sm"
                  [ngClass]="
                    selectedRole?.id === role.id
                      ? 'bg-indigo-600 text-white'
                      : 'bg-slate-100 text-slate-700'
                  "
                >
                  {{ role.name }}
                </div>

                <!-- INFO -->
                <div>

                  <h4 class="font-semibold text-slate-800">
                    {{ role.description | translate }}
                  </h4>

                

                </div>

              </div>

              <!-- ACTIONS -->
              <!-- <div class="flex items-center gap-3">

                <button
                  class="text-blue-500 hover:text-blue-700 transition"
                  (click)="editRole(role); $event.stopPropagation()"
                >
                  <fa-icon
                    [icon]="AppIcons.edit"
                    class="text-sm"
                  ></fa-icon>
                </button>

                <button
                  class="text-red-500 hover:text-red-700 transition"
                  (click)="deleteRole(role); $event.stopPropagation()"
                >
                  <fa-icon
                    [icon]="AppIcons.delete"
                    class="text-sm"
                  ></fa-icon>
                </button>

              </div> -->

            </div>

          </div>

        </div>

      </div>

    </div>

    <!-- RIGHT PANEL -->
    <div class="col-span-12 xl:col-span-9">

      <div class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">

        <!-- HEADER -->
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50">

          <div class="flex items-center justify-between flex-wrap gap-4">

            <!-- LEFT -->
            <div>

              <h3 class="text-2xl font-bold text-slate-800">
                {{ selectedRole?.description | translate }}
              </h3>

              <p class="text-sm text-slate-500 mt-1">
                {{ 'SETUP.ROLES.CONFIGURE_PERMISSIONS' | translate }}
              </p>

            </div>

            <!-- BADGES -->
            <div class="flex items-center gap-2">

              <div
                class="px-3 py-2 rounded-xl bg-indigo-100 text-indigo-700 text-sm font-medium"
              >
                {{ 'SETUP.ROLES.MODULES_COUNT' | translate: { count: permissionModules.length } }}
              </div>

            </div>

          </div>

        </div>

        <!-- MODULES -->
        <div class="p-5 space-y-4">

          <div
            *ngFor="let module of permissionModules"
            class="border border-slate-200 rounded-2xl overflow-hidden"
          >

            <!-- MODULE HEADER -->
            <div
              class="px-5 py-4 flex items-center justify-between cursor-pointer bg-white hover:bg-slate-50 transition"
              (click)="module.expanded = !module.expanded"
            >

              <!-- LEFT -->
              <div class="flex items-center gap-4">

                <!-- ICON -->
                <div
                  class="w-12 h-12 rounded-xl bg-indigo-100 text-indigo-700 flex items-center justify-center font-bold text-sm uppercase"
                >
{{ module?.name?.charAt(0) || 'M' }}                </div>

                <!-- INFO -->
                <div>

                  <h4 class="font-semibold text-slate-800 text-lg">
                    {{ module.name | translate }}
                  </h4>

                  <p class="text-sm text-slate-500 mt-1">
                    {{ 'SETUP.ROLES.PERMISSIONS_COUNT' | translate: { count: module.permissions.length } }}
                  </p>

                </div>

              </div>

              <!-- RIGHT -->
              <div class="flex items-center gap-4">

                <div
                  class="px-3 py-1 rounded-lg bg-indigo-100 text-indigo-700 text-xs font-semibold"
                >
                  {{ getAllowedCount(module.permissions) }}/{{ module.permissions.length }}
                </div>

                <i
                  class="pi text-slate-500"
                  [ngClass]="module.expanded ? 'pi-chevron-up' : 'pi-chevron-down'"
                ></i>

              </div>

            </div>

            <!-- BODY -->
            <div
              *ngIf="module.expanded"
              class="border-t border-slate-200 p-5 bg-slate-50"
            >

              <!-- PERMISSIONS -->
              <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">

                <label
                  *ngFor="let permission of module.permissions"
                  class="flex items-center gap-3 border border-slate-200 rounded-xl bg-white px-4 py-3 cursor-pointer hover:border-indigo-300 transition"
                >

                  <input
                    type="checkbox"
                    [(ngModel)]="permission.allowed"
                    class="w-4 h-4 accent-indigo-600"
                  />

                  <span class="text-sm font-medium text-slate-700">
                    {{ permission.label | translate }}
                  </span>

                </label>

              </div>

            </div>

          </div>

        </div>

        <!-- FOOTER -->
        <div
          class="px-6 py-4 border-t border-slate-200 bg-slate-50 flex justify-end gap-3"
        >

          <button
            class="h-11 px-6 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold transition"
            (click)="savePermissions()"
            [disabled]="loading"
          >
            {{ (loading ? 'COMMON.SAVING' : 'SETUP.ROLES.SAVE_PERMISSIONS') | translate }}
          </button>

        </div>

      </div>

    </div>

  </div>

</div>